class InternationalPhoneNumber {
    constructor(
        formElementGuid
    ) {
        this.formElementGuid = formElementGuid;
    }
    generateHtml(templateId, data){
        let template = document.getElementById(templateId).innerHTML;
        const html = template.replace(/\{\{(.*?)\}\}/g, (match, key) => data[key] || '');
        return html;
    }
    renderHtml(containerId, templateId, data) {
        const html = this.generateHtml(templateId, data);
        document.getElementById(containerId).insertAdjacentHTML("beforeend", html);
        this.setSelectedDialCode(data.dialCode);
        this.addEventListeners();
    }
    setSelectedDialCode(value) {
        const countryCodeField = document.getElementById(`${this.formElementGuid}_phoneCountryCode`);
        const options = countryCodeField.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].value === value) {
            options[i].selected = true;
            break;
          }
        }
        countryCodeField.dispatchEvent(new Event('change'));
    }
    addEventListeners() {
        const valueInput = document.getElementById(this.formElementGuid);
        const phoneNumberField = document.getElementById(`${this.formElementGuid}_phoneNumber`);
        const countryCodeField = document.getElementById(`${this.formElementGuid}_phoneCountryCode`);
        valueInput.addEventListener('change', e => {
            const phoneNumber = e.detail?.phone;
            const countryCode = e.detail?.countryCode ?? 'SE';

            if (countryCode && countryCode != null) {
                this.setCountryCodeByCulture(countryCode);
            }
            if (phoneNumber && phoneNumber != null) {
                if (phoneNumber.startsWith('+') || phoneNumber.startsWith('00')) {
                    const number = phoneNumber.substring(phoneNumber.startsWith('+') ? 1 : 2);
                    this.setCultureSpecificNumber(number);
                }
                else {
                    this.setLocalNumber(phoneNumber);
                }
            }
            this.updateValueInput();
        });
        phoneNumberField.addEventListener('blur', () => {
            this.updateValueInput();
        });
        countryCodeField.addEventListener('blur', () => { 
            this.updateValueInput();
        });
    }
    updateValueInput(){
        const valueInput = document.getElementById(this.formElementGuid);
        const countryCodeField = document.getElementById(`${this.formElementGuid}_phoneCountryCode`);
        const phoneNumberField = document.getElementById(`${this.formElementGuid}_phoneNumber`);
        const countryCode = countryCodeField.value;
        let phoneNumber = phoneNumberField.value;
        // Normalize phone number by removing spaces, dashes, parentheses, and leading plus sign
        phoneNumber = String(phoneNumber).trim().replace(/^\+/, '').replace(/\D/g, '');
        // Remove leading '00' or '0' for specific country codes (e.g., Sweden '46')
        if(phoneNumber.startsWith('00')) phoneNumber = phoneNumber.substring(2);
        // Remove leading '0' for specific country codes (e.g., Sweden '46')
        if(phoneNumber.startsWith('0') && countryCode == "46")  phoneNumber = phoneNumber.substring(1);
        // Remove country code if it is already included in the phone number
        if(phoneNumber.startsWith(countryCode)) phoneNumber = phoneNumber.substring(countryCode.length);

        countryCodeField.value = countryCode; // Ensure the country code field is updated
        phoneNumberField.value = phoneNumber; // Ensure the phone number field is updated
        if (countryCode.length > 0 && phoneNumber.length > 0) {
            valueInput.value = "00" + countryCode + phoneNumber;
        } else {
            valueInput.value = "";
        }
    }
    setCountryCodeByCulture(countryCode) {
        const countryCodeField = document.getElementById(`${this.formElementGuid}_phoneCountryCode`);
        if (countryCodeField) {
            const options = countryCodeField.options;
            for (var i = 0; i < options.length; i++) {
                if (options[i].getAttribute('data-countryCode') === countryCode) {
                    options[i].selected = true;
                    break;
                }
            }
        }
    }
    setCultureSpecificNumber(culturedNumber) {
        const phoneNumberField = document.getElementById(`${this.formElementGuid}_phoneNumber`);
        const countryCodeField = document.getElementById(`${this.formElementGuid}_phoneCountryCode`);
        for (let length = 4; length > 0; length--) { // Country codes can be 1-3 digits
            const countryCode = culturedNumber.substring(0, length);
            if (countryCodeField) {
                const options = countryCodeField.options;
                for (var i = 0; i < options.length; i++) {
                    if (options[i].value === countryCode) {
                        options[i].selected = true;
                        const rightPartPhoneNumber = culturedNumber.substring(length);
                        phoneNumberField.value = rightPartPhoneNumber;
                        break;
                    }
                }
            }
        }
    }
    setLocalNumber(localNumber) {
        const phoneNumberField = document.getElementById(`${this.formElementGuid}_phoneNumber`);
        const countryCodeField = document.getElementById(`${this.formElementGuid}_phoneCountryCode`);
        if (countryCodeField) {
            var options = countryCodeField.options;
            for (var i = 0; i < options.length; i++) {
                if (options[i].selected == true) {
                    phoneNumberField.value = localNumber.startsWith('0') && options[i].value == "46" ? localNumber.substring(1) : localNumber;
                    break;
                }
            }
        }
    }
}
window.FalckComponents = {
    ...window.FalckComponents,
    InternationalPhoneNumber: InternationalPhoneNumber,
};